import { ArrowBack, ArrowForward, DarkMode, LightMode, Menu, MenuOpen } from "@mui/icons-material";
import {
  Box,
  Breadcrumbs,
  Button,
  IconButton,
  Link,
  Toolbar,
  useMediaQuery
} from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { styled, useTheme } from "@mui/material/styles";
import LanguageSelector from "app/partials/layout/LanguageSelector";
import UserProfile from "app/partials/layout/UserProfile";
import React from "react";
import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";
import { translatePageName, determineActionName } from "./utils";
import { useTranslation } from "_metronic/i18n/language";
import Brand from "../brand/Brand";
import { useRTL } from "themes/RTLProvider/RTLProvider";
import { useThemeApp } from "_metronic/materialUIThemeProvider/ThemeProvider";
import { ASIDE_WIDTH } from "../aside/layoutConstants";

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}
const drawerHeight = 64;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== "open"
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  height: drawerHeight,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  ...(open && {
    marginLeft: ASIDE_WIDTH,
    width: `calc(100% - ${ASIDE_WIDTH}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}));

const Topbar: React.FC<{
  open?: boolean;
  onOpenMenu?: any;
}> = ({ open, onOpenMenu }) => {
  const translate = useTranslation();
  const { goBack } = useHistory();
  const { pathname } = useLocation();
  const theme = useTheme();
  const { toggleTheme, isDarkMode } = useThemeApp();
  const isMobileView = useMediaQuery(theme.breakpoints.down("sm"));

  const isRtl = useRTL();
  const arrowIcon = isRtl ? <ArrowForward /> : <ArrowBack />;

  const splitPathname = pathname.split("/").filter(Boolean);

  return (
    <AppBar position="fixed" open={open}>
      <Toolbar
        style={{
          height: "100%",
          display: "flex",
          justifyContent: "space-between"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {/* {isMobileView && <Brand />} */}
          {!open && <Brand />}
          <Button color="inherit" onClick={goBack}>
            {arrowIcon}
          </Button>
        </Box>
        {!isMobileView && (
          <Breadcrumbs
            aria-label="breadcrumb"
            sx={{ flexGrow: 1, textAlign: isMobileView ? "center" : "left" }}
          >
            {splitPathname.map((path, index) => (
              <Link
                key={index}
                underline="hover"
                color="inherit"
                component={RouterLink}
                to={"/" + splitPathname.slice(0, index + 1).join("/")}
              >
                {index === splitPathname.length - 1
                  ? determineActionName(
                      "/" + splitPathname.slice(0, index + 1).join("/"),
                      translate
                    ) ||
                    translatePageName(
                      "/" + splitPathname.slice(0, index + 1).join("/"),
                      translate
                    )
                  : translatePageName(
                      "/" + splitPathname.slice(0, index + 1).join("/"),
                      translate
                    )}
              </Link>
            ))}
          </Breadcrumbs>
        )}

        <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={toggleTheme}
              sx={{ marginRight: 1 }}
            >
              {isDarkMode ? <LightMode /> : <DarkMode />}
            </IconButton>
          {isMobileView && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={onOpenMenu}
              sx={{ marginRight: 1 }}
            >
              {open ? <MenuOpen /> : <Menu />}
            </IconButton>
          )}
          <LanguageSelector iconType="" />
          <UserProfile showBadge={true} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
